import React from "react";
import * as Option from "fp-ts/lib/Option";
import { ProgramStaticHero, ProgramDynamicHero } from "hero";
import { config } from "core/utils";
export var block = function (data) {
    return Option.some({
        key: config.blockKeys.programHero,
        View: function () {
            switch (data.hero.type) {
                case "StaticHero":
                    return (React.createElement(ProgramStaticHero, { hero: data.hero, trackingEnabled: !data.fetchingData, votingEnabled: data.votingId ? true : false }));
                case "ProgramDynamicHero":
                    return (React.createElement(ProgramDynamicHero, { hero: data.hero, linkedTitle: false, trackingEnabled: !data.fetchingData, votingEnabled: data.votingId ? true : false }));
            }
        },
    });
};
